import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import StorefrontApiService from '@services/StorefrontApiService';

const api = new StorefrontApiService();

const useApplicationStore = create(
    persist(
        (set, get) => ({
            marketingLabels: {},
            surrogateKeys: [],
            notifications: [],
            methods: {
                async warmupStaticProperties() {
                    const labels = await api.fetchMarketingLabels();
                    set({ marketingLabels: labels.marketingLabels });
                },
                setSurrogateKeys(keys) {
                    set({ surrogateKeys: keys });
                },
                getMarketingLabels(propertyIds) {
                    const labels = get().marketingLabels;
                    return propertyIds?.filter((id) => labels?.[id]).map((id) => {
                        return labels[id];
                    }) || [];
                },
                notify(msg, options) {
                    const id = btoa((new Date()).getTime());
                    const message = {
                        type: 'standard',
                        ...options,
                        id,
                        message: msg,
                        timestamp: new Date(),
                        inFocus: false,
                        close: () => {
                            removeNotification();
                        },
                        onMouseEnter: () => {
                            set({
                                notifications: get().notifications.map(n =>
                                    n.id === id ? { ...n, inFocus: true } : n
                                ),
                            });
                        },
                        onMouseLeave: () => {
                            set({
                                notifications: get().notifications.map(n =>
                                    n.id === id ? { ...n, inFocus: false } : n
                                ),
                            });
                        },
                    };

                    const removeNotification = () => {
                        set({
                            notifications: get().notifications.map(n =>
                                n.id === id && n.inFocus === false ? { ...n, removing: true } : n
                            ),
                        });

                        // Remove notification after fade-out duration (0.5s)
                        setTimeout(() => {
                            set({ notifications: get().notifications.filter(n => n.id !== id && n.inFocus === false) });
                        }, 200);
                    };

                    set({ notifications: [ message, ...get().notifications ]});

                    // Start fade-out animation before removing
                    setTimeout(() => {
                        removeNotification();
                    }, 5000);
                },
            },
        }),
        {
            name: 'app-storage',
            partialize: (state) => ({
                marketingLabels: state.marketingLabels,
            }),
        },
    ),
);

export default useApplicationStore;
